(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (customElements.get('details-disclosure')) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true);
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holt-benefits"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-bn-toggle]');
    if (!toggle) return;

    var row = toggle.closest('[data-bn-row]');
    var root = toggle.closest('[data-holt-bn]');
    if (!row || !root) return;

    var opening = !row.classList.contains('is-open');

    /* accordion mode: close the others first */
    if (opening && root.dataset.single === 'true') {
      root.querySelectorAll('[data-bn-row].is-open').forEach(function (other) {
        if (other === row) return;
        other.classList.remove('is-open');
        var t = other.querySelector('[data-bn-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    row.classList.toggle('is-open', opening);
    toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holt-bento"] && !Shopify.designMode) return;
  try {
    
  /* Track the pointer across each card and hand the position to CSS.
     Delegated from document so it survives section re-renders in the editor,
     and rAF-throttled so it costs nothing on scroll. */
  (function () {
    var pending = false, last = null;

    function apply() {
      pending = false;
      if (!last) return;
      var card = last.card, r = card.getBoundingClientRect();
      card.style.setProperty('--mx', ((last.x - r.left) / r.width * 100) + '%');
      card.style.setProperty('--my', ((last.y - r.top) / r.height * 100) + '%');
    }

    document.addEventListener('mousemove', function (e) {
      var card = e.target.closest && e.target.closest('.holt-bento__card');
      if (!card) return;
      var section = card.closest('[data-holt-bento]');
      if (!section || section.dataset.glow !== 'true') return;
      last = { card: card, x: e.clientX, y: e.clientY };
      if (!pending) { pending = true; requestAnimationFrame(apply); }
    }, { passive: true });

    /* recentre on the way out so the next hover fades in from the middle */
    document.addEventListener('mouseout', function (e) {
      var card = e.target.closest && e.target.closest('.holt-bento__card');
      if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
      card.style.removeProperty('--mx');
      card.style.removeProperty('--my');
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holt-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var root = e.target.closest('[data-holt-bb]');
    if (!root) return;

    /* ---------- gallery ---------- */
    var thumb = e.target.closest('.holt-bb__thumb');
    if (thumb) {
      var main = document.getElementById(thumb.dataset.target);
      if (main) main.src = thumb.dataset.full;
      root.querySelectorAll('.holt-bb__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      return;
    }

    function chosen() {
      var total = 0;
      root.querySelectorAll('[data-bb-count]').forEach(function (c) {
        total += parseInt(c.textContent, 10) || 0;
      });
      return total;
    }

    function packs() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-bb-pack]'));
    }

    /* the tier you've reached, based on how many boxes are in the bundle */
    function tierFor(count) {
      var list = packs();
      if (!list.length) return null;
      var reached = list[0];
      list.forEach(function (p) {
        if (count >= (parseInt(p.dataset.size, 10) || 0)) reached = p;
      });
      return reached;
    }

    function refresh() {
      var have = chosen();
      var list = packs();

      /* move the slider to the tier reached */
      var tier = tierFor(have);
      list.forEach(function (p) { p.classList.toggle('is-active', p === tier); });

      /* fill the rail up to that tier */
      if (list.length > 1 && tier) {
        var idx = list.indexOf(tier);
        var pct = (idx / (list.length - 1)) * 76;
        root.style.setProperty('--holt-rail-fill', pct + '%');
      }

      var need = tier ? parseInt(tier.dataset.size, 10) || 0 : 0;
      var chosenEl = root.querySelector('[data-bb-chosen]');
      var reqEl = root.querySelector('[data-bb-required]');
      if (chosenEl) chosenEl.textContent = have;
      if (reqEl) reqEl.textContent = need;

      /* the saving always reflects the tier shown, so it starts at the
         smallest pack's discount rather than 0% */
      var savingEl = root.querySelector('[data-bb-saving]');
      if (savingEl && tier) savingEl.textContent = (tier.dataset.discount || 0) + '%';

      /* headline price follows the tier, with no "/ea" suffix */
      var unitEl = root.querySelector('[data-bb-unit-price]');
      if (unitEl && tier) unitEl.textContent = tier.dataset.unitPlain || tier.dataset.unit || '';
      var subEl = root.querySelector('[data-bb-sub-price]');
      if (subEl && tier) subEl.textContent = tier.dataset.unitPlain || tier.dataset.unit || '';

      /* need at least the smallest pack before checkout */
      var min = list.length ? (parseInt(list[0].dataset.size, 10) || 1) : 1;
      var floor = parseInt(root.dataset.bbMin, 10) || 0;
      if (floor > min) min = floor;
      var cta = root.querySelector('[data-bb-add-to-cart]');
      if (cta) cta.disabled = have < min;

      var totalEl = root.querySelector('[data-bb-total]');
      if (totalEl) totalEl.textContent = have > 0 ? have + ' × ' : '';

      root.querySelectorAll('[data-bb-item]').forEach(function (item) {
        var countEl = item.querySelector('[data-bb-count]');
        if (!countEl) return;
        var n = parseInt(countEl.textContent, 10) || 0;
        var qty = item.querySelector('[data-bb-qty]');
        var add = item.querySelector('[data-bb-add]');
        if (qty) qty.hidden = n === 0;
        if (add) add.style.display = n === 0 ? '' : 'none';
        item.classList.toggle('is-selected', n > 0);
      });
    }

    /* ---------- pack size ---------- */
    /* tiers are driven by how many boxes are chosen, so a click is just a hint */
    var pack = e.target.closest('[data-bb-pack]');
    if (pack) { refresh(); return; }

    /* ---------- add / plus / minus ---------- */
    var add = e.target.closest('[data-bb-add]');
    var plus = e.target.closest('[data-bb-plus]');
    var minus = e.target.closest('[data-bb-minus]');
    if (add || plus || minus) {
      var item = e.target.closest('[data-bb-item]');
      if (!item) return;
      var countEl = item.querySelector('[data-bb-count]');
      var n = parseInt(countEl.textContent, 10) || 0;

      if (add || plus) {
        n += 1;
      } else if (minus) {
        n = Math.max(0, n - 1);
      }
      countEl.textContent = n;
      refresh();
      return;
    }

    /* ---------- add to cart (both buttons) ---------- */
    var onetime = e.target.closest('[data-bb-onetime]');
    var cta = onetime ? root.querySelector('[data-bb-add-to-cart]') : e.target.closest('[data-bb-add-to-cart]');
    if (!cta || cta.disabled) return;

    /* the small link buys once; the main button follows the selected offer */
    var subscribing = true;
    if (onetime) {
      subscribing = false;
    } else {
      var offerRadio = root.querySelector('[data-bb-offer] input[type="radio"]');
      subscribing = !!(offerRadio && offerRadio.checked);
    }

    var msg = root.querySelector('[data-bb-msg]');
    var label = root.querySelector('[data-bb-cta-label]');
    var original = label.textContent;

    function say(t, err) {
      if (!msg) return;
      msg.hidden = false;
      msg.textContent = t;
      msg.classList.toggle('is-error', !!err);
    }

    var items = [];
    var missingProduct = false;
    root.querySelectorAll('[data-bb-item]').forEach(function (item) {
      var countEl = item.querySelector('[data-bb-count]');
      if (!countEl) return;
      var n = parseInt(countEl.textContent, 10) || 0;
      if (n < 1) return;
      if (!item.dataset.variant) { missingProduct = true; return; }
      var line = { id: Number(item.dataset.variant), quantity: n };
      if (subscribing && cta.dataset.plan) line.selling_plan = Number(cta.dataset.plan);
      if (subscribing && !cta.dataset.plan) line.properties = { 'Purchase type': 'Subscription' };
      items.push(line);
    });

    if (!items.length) { say('Choose your flavours first.', true); return; }
    if (missingProduct) { say('One of these flavours is not linked to a product yet.', true); return; }

    cta.disabled = true;
    label.textContent = 'Adding…';

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        cta.disabled = false;
        label.textContent = original;
        if (!res.ok) { say(res.data.description || res.data.message || 'Could not add to cart.', true); return; }
        var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        var go = cta.dataset.redirect;
        var dest = go === 'checkout' ? '/checkout' : (rootUrl + 'cart');

        /* apply the tier discount, plus the subscriber code if there is one */
        var tier = root.querySelector('[data-bb-pack].is-active');
        var codes = [];
        if (tier && tier.dataset.code) codes.push(tier.dataset.code);
        if (subscribing && cta.dataset.subCode) codes.push(cta.dataset.subCode);

        if (codes.length) {
          /* Shopify applies the code, then sends the shopper on to dest */
          window.location.href = '/discount/' + encodeURIComponent(codes.join(',')) + '?redirect=' + encodeURIComponent(dest);
          return;
        }
        if (go === 'stay') { say('Added to your cart.', false); return; }
        if (go === 'drawer' && typeof window.holtOpenCart === 'function') {
          say('Added to your cart.', false);
          window.holtOpenCart();
          return;
        }
        window.location.href = dest;
      })
      .catch(function () {
        cta.disabled = false;
        label.textContent = original;
        say('Something went wrong. Please try again.', true);
      });
  });

  /* set the initial counts on load */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-holt-bb]').forEach(function (root) {
      var active = root.querySelector('[data-bb-pack].is-active');
      var reqEl = root.querySelector('[data-bb-required]');
      if (active && reqEl) reqEl.textContent = active.dataset.size;
      var savingEl = root.querySelector('[data-bb-saving]');
      if (active && savingEl) savingEl.textContent = (active.dataset.discount || 0) + '%';
      var unitEl = root.querySelector('[data-bb-unit-price]');
      if (active && unitEl) unitEl.textContent = active.dataset.unitPlain || active.dataset.unit || '';
      var cta = root.querySelector('[data-bb-add-to-cart]');
      if (cta && active) cta.disabled = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holt-closer-look"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cl-prev], [data-cl-next]');
    if (!btn) return;

    var root = btn.closest('[data-holt-cl]');
    if (!root) return;
    var rail = root.querySelector('[data-cl-rail]');
    if (!rail) return;

    var card = rail.querySelector('.holt-cl__card');
    /* one card plus the gap, so the rail lands cleanly on the next card */
    var step = card ? card.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
    if (card) {
      var styles = window.getComputedStyle(rail);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      step = card.getBoundingClientRect().width + gap;
    }

    rail.scrollBy({ left: btn.hasAttribute('data-cl-prev') ? -step : step, behavior: 'smooth' });
  });

  /* grey out the arrows at each end */
  (function () {
    function sync(rail) {
      var root = rail.closest('[data-holt-cl]');
      if (!root) return;
      var prev = root.querySelector('[data-cl-prev]');
      var next = root.querySelector('[data-cl-next]');
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
    }
    function init() {
      document.querySelectorAll('[data-holt-cl] [data-cl-rail]').forEach(function (rail) {
        sync(rail);
        rail.addEventListener('scroll', function () { sync(rail); }, { passive: true });
      });
    }
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState !== 'loading') init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holt-flavours"] && !Shopify.designMode) return;
  try {
    
  /* Whole card clickable. The invisible overlay link handles it in CSS; this is a
     fallback for cases where something else stacks above the overlay. */
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.holt-flav__card');
    if (!card) return;
    /* let real links do their own thing */
    if (e.target.closest('a')) return;
    var cover = card.querySelector('.holt-flav__cover');
    var href = cover && cover.getAttribute('href');
    if (href && href !== '#') window.location.href = href;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holt-footer"] && !Shopify.designMode) return;
  try {
    
  /* Columns are <details>: open on desktop, collapsed on mobile like Humantra. */
  (function () {
    var BP = 749;
    function sync() {
      var cols = document.querySelectorAll('[data-holt-col]');
      if (!cols.length) return;
      var isMobile = window.matchMedia('(max-width: ' + BP + 'px)').matches;
      cols.forEach(function (c) {
        if (isMobile) {
          if (!c.dataset.holtTouched) c.removeAttribute('open');
        } else {
          c.setAttribute('open', '');
          delete c.dataset.holtTouched;
        }
      });
    }
    /* remember what the visitor opened so resizing doesn't fight them */
    document.addEventListener('click', function (e) {
      var s = e.target.closest('[data-holt-col] > summary');
      if (s) s.parentElement.dataset.holtTouched = 'true';
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else { sync(); }
    window.addEventListener('resize', sync);
    document.addEventListener('shopify:section:load', sync);
  })();

  /* ---- newsletter -> Klaviyo ----------------------------------------
     Shopify's {% form 'customer' %} only creates a Shopify customer and relies
     on Klaviyo's background sync, which lags and sometimes misses. This posts
     straight to Klaviyo's client subscription endpoint instead, so the profile
     appears immediately and consent is recorded against the list.
     Delegated from document so it survives section re-renders in the editor. */
  (function () {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList || !form.classList.contains('holt-footer__form')) return;

      var wrap = form.closest('[data-holt-klaviyo]');
      if (!wrap) return;                       /* keys not set — leave Shopify's form alone */

      var input = form.querySelector('input[type="email"]');
      var email = input && input.value.trim();
      if (!email) return;

      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = '...'; }

      function done(msg, ok) {
        var p = wrap.querySelector('.holt-footer__success');
        if (!p) {
          p = document.createElement('p');
          p.className = 'holt-footer__success';
          wrap.appendChild(p);
        }
        p.textContent = msg;
        p.style.opacity = ok ? '' : '.75';
        if (ok) form.style.display = 'none';
        else if (btn) { btn.disabled = false; btn.textContent = label; }
      }

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(wrap.dataset.klaviyoKey), {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Website footer',
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: wrap.dataset.klaviyoList } } }
          }
        })
      })
        .then(function (r) {
          if (r.status === 202 || r.ok) done(wrap.dataset.klaviyoSuccess, true);
          else done(wrap.dataset.klaviyoError, false);
        })
        .catch(function () { done(wrap.dataset.klaviyoError, false); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holt-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var root = e.target.closest('[data-holt-pdp]');
    if (!root) return;

    /* thumbnails */
    var thumb = e.target.closest('.holt-pdp__thumb');
    if (thumb) {
      var main = document.getElementById(thumb.dataset.target);
      var vid  = thumb.dataset.videoTarget ? document.getElementById(thumb.dataset.videoTarget) : null;
      var wantsVideo = thumb.dataset.type === 'video' && thumb.dataset.video;

      /* whatever we are moving to, stop whatever was playing */
      if (vid) { try { vid.pause(); } catch (err) {} }

      if (wantsVideo && vid) {
        /* only reload when the clip actually changes, or every click
           restarts the download */
        if (vid.getAttribute('data-src') !== thumb.dataset.video) {
          vid.setAttribute('data-src', thumb.dataset.video);
          vid.innerHTML = '';
          var sEl = document.createElement('source');
          sEl.src = thumb.dataset.video;
          sEl.type = 'video/mp4';
          vid.appendChild(sEl);
          vid.load();
        }
        if (thumb.dataset.full) vid.poster = thumb.dataset.full;
        if (main) main.hidden = true;
        vid.hidden = false;
        var pr = vid.play();
        /* autoplay can be refused; the poster still shows, so do not throw */
        if (pr && pr.catch) pr.catch(function () {});
      } else if (main) {
        if (vid) vid.hidden = true;
        main.hidden = false;
        /* srcset wins over src, so it has to be cleared or the browser keeps
           showing the old responsive candidate */
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = thumb.dataset.full;
      }
      root.querySelectorAll('.holt-pdp__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (window.holtRevealThumb) window.holtRevealThumb(thumb);
      return;
    }

    /* gallery arrows */
    var prev = e.target.closest('[data-holt-prev]');
    var next = e.target.closest('[data-holt-next]');
    if (prev || next) {
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('.holt-pdp__thumb'));
      if (!thumbs.length) return;
      var i = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      if (i < 0) i = 0;
      i = next ? (i + 1) % thumbs.length : (i - 1 + thumbs.length) % thumbs.length;
      thumbs[i].click();
      return;
    }

    /* quantity */
    var qtyBtn = e.target.closest('[data-holt-qty]');
    if (qtyBtn) {
      var input = root.querySelector('[data-holt-qty-input]');
      var v = parseInt(input.value, 10) || 1;
      v += parseInt(qtyBtn.dataset.holtQty, 10);
      input.value = Math.max(1, v);
      return;
    }

    /* offer selection */
    var offer = e.target.closest('[data-holt-offer]');
    if (offer) {
      root.querySelectorAll('[data-holt-offer]').forEach(function (o) { o.classList.remove('is-selected'); });
      offer.classList.add('is-selected');
      var radio = offer.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      return;
    }

    /* add to cart */
    var btn = e.target.closest('[data-holt-atc]');
    if (!btn || btn.disabled) return;

    var msg = root.querySelector('[data-holt-msg]');
    var label = root.querySelector('[data-holt-atc-label]');
    var original = label.textContent;

    function say(text, isError) {
      if (!msg) return;
      msg.hidden = false;
      msg.textContent = text;
      msg.classList.toggle('is-error', !!isError);
    }

    var qty = parseInt(root.querySelector('[data-holt-qty-input]').value, 10) || 1;
    var selected = root.querySelector('[data-holt-offer].is-selected');
    var mode = selected ? selected.dataset.holtOffer : 'onetime';

    var line = { id: Number(btn.dataset.variant), quantity: qty, properties: {} };

    if (mode === 'subscribe') {
      var freq = root.querySelector('[data-holt-frequency]');
      var planFromOption = freq && freq.value ? freq.value : '';
      var plan = planFromOption || btn.dataset.plan || '';
      if (plan) {
        line.selling_plan = Number(plan);
      } else if (freq) {
        line.properties['Delivery'] = freq.options[freq.selectedIndex].text;
      }
    }

    btn.disabled = true;
    label.textContent = 'Adding…';

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [line] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        btn.disabled = false;
        label.textContent = original;
        if (!res.ok) {
          say(res.data.description || res.data.message || 'Could not add to cart.', true);
          return;
        }
        var go = btn.dataset.redirect;
        var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        if (go === 'checkout') { window.location.href = '/checkout'; }
        else if (go === 'cart') { window.location.href = rootUrl + 'cart'; }
        else if (go === 'drawer' && typeof window.holtOpenCart === 'function') { window.holtOpenCart(e); }
        else {
          say('Added to your cart.', false);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        }
      })
      .catch(function () {
        btn.disabled = false;
        label.textContent = original;
        say('Something went wrong. Please try again.', true);
      });
  });

  /* keep the subscribe price in step with the chosen frequency */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-holt-frequency]');
    if (!sel) return;
    var root = sel.closest('[data-holt-pdp]');
    if (!root) return;
    var opt = sel.options[sel.selectedIndex];
    var price = opt && opt.dataset ? opt.dataset.price : '';
    if (!price) return;
    var target = root.querySelector('[data-holt-sub-price]');
    if (target) target.textContent = price;
  });

  /* ---------- desktop pinned bar ----------
     The buy panel now scrolls normally (the gallery is the sticky column),
     so the add-to-cart button does leave the viewport and an
     IntersectionObserver would work. The measure-once approach is kept
     because it also handles the case where the button starts off-screen on
     a short window, which the observer does not. */
  (function () {
    function init() {
      document.querySelectorAll('[data-holt-pdp]').forEach(function (root) {
        var bar = root.querySelector('[data-holt-bar]');
        var buy = root.querySelector('[data-holt-buy]');
        if (!bar || !buy || bar.dataset.bound === '1') return;
        bar.dataset.bound = '1';
        bar.hidden = false;

        var trigger = 0;
        var ticking = false;
        /* how far down the viewport the button has to travel before the bar
           appears. 0 = only once it leaves the very top, 100 = the moment it
           passes the bottom of the screen. */
        var lead = (parseInt(bar.dataset.trigger, 10) || 0) / 100;

        function measure() {
          /* The panel is no longer sticky, so its position in the document
             is its real position and no neutralising is needed. */
          trigger = buy.getBoundingClientRect().bottom + window.pageYOffset;
        }

        function update() {
          ticking = false;
          var seen = window.pageYOffset + (window.innerHeight * lead);
          bar.classList.toggle('is-visible', seen > trigger);
        }

        function onScroll() {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(update);
        }

        measure();
        update();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', function () { measure(); update(); }, { passive: true });
        /* images loading later can shift the layout under us */
        window.addEventListener('load', function () { measure(); update(); });
      });
    }
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState !== 'loading') init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holt-starter-pack"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.holt-sp__thumb');
    if (thumb) {
      var main = document.getElementById(thumb.dataset.target);
      if (main) main.src = thumb.dataset.full;
      thumb.parentElement.querySelectorAll('.holt-sp__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      return;
    }

    var toggle = e.target.closest('[data-dd-toggle]');
    document.querySelectorAll('[data-dd-menu]').forEach(function (m) {
      if (!toggle || m !== toggle.parentElement.querySelector('[data-dd-menu]')) m.hidden = true;
    });
    if (toggle) {
      var menu = toggle.parentElement.querySelector('[data-dd-menu]');
      menu.hidden = !menu.hidden;
      return;
    }

    var opt = e.target.closest('[data-dd-opt]');
    if (opt) {
      var dd = opt.closest('[data-dd]');
      var val = dd.querySelector('[data-dd-value]');
      val.textContent = opt.dataset.label;
      val.dataset.variant = opt.dataset.variant || '';
      val.dataset.plan = opt.dataset.plan || '';
      dd.dataset.chosen = 'true';
      dd.querySelector('[data-dd-menu]').hidden = true;
      var wrap = dd.closest('.holt-sp');
      if (wrap) {
        var msg = wrap.querySelector('[data-sp-msg]');
        if (msg) { msg.hidden = true; }
      }
      return;
    }

    var addBtn = e.target.closest('[data-sp-add]');
    if (!addBtn) return;

    var root = addBtn.closest('.holt-sp');
    var msg = root.querySelector('[data-sp-msg]');
    var label = root.querySelector('[data-sp-cta-label]');
    var original = label.textContent;

    function say(text, isError) {
      msg.hidden = false;
      msg.textContent = text;
      msg.classList.toggle('is-error', !!isError);
    }

    var flavourDds = root.querySelectorAll('[data-dd-role="flavour"]');
    var items = [];
    var missing = false;
    var noProduct = false;

    flavourDds.forEach(function (dd) {
      var val = dd.querySelector('[data-dd-value]');
      if (dd.dataset.chosen !== 'true') { missing = true; return; }
      if (!val.dataset.variant) { noProduct = true; return; }
      items.push({ id: Number(val.dataset.variant), label: val.textContent.trim() });
    });

    if (missing) { say(addBtn.dataset.errorFlavour || 'Please choose both flavours.', true); return; }
    if (noProduct) { say('This flavour is not linked to a product yet. Add one in the theme editor.', true); return; }

    var freqDd = root.querySelector('[data-dd-role="frequency"]');
    var freqLabel = '';
    var sellingPlan = '';
    if (freqDd) {
      var fv = freqDd.querySelector('[data-dd-value]');
      freqLabel = fv.textContent.trim();
      sellingPlan = fv.dataset.plan || '';
    }

    // merge duplicate flavours into one line with quantity 2
    var merged = {};
    items.forEach(function (it) {
      if (merged[it.id]) { merged[it.id].quantity += 1; }
      else { merged[it.id] = { id: it.id, quantity: 1, properties: {} }; }
    });

    var payload = Object.keys(merged).map(function (k) {
      var line = merged[k];
      if (freqLabel) { line.properties[addBtn.dataset.freqLabel || 'Delivery'] = freqLabel; }
      if (sellingPlan) { line.selling_plan = Number(sellingPlan); }
      return line;
    });

    addBtn.disabled = true;
    label.textContent = 'Adding…';

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: payload })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        addBtn.disabled = false;
        label.textContent = original;
        if (!res.ok) {
          say(res.data.description || res.data.message || 'Could not add to cart.', true);
          return;
        }
        var go = addBtn.dataset.redirect;
        if (go === 'checkout') { window.location.href = '/checkout'; }
        else if (go === 'cart') { window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart'; }
        else {
          say('Added to your cart.', false);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        }
      })
      .catch(function () {
        addBtn.disabled = false;
        label.textContent = original;
        say('Something went wrong. Please try again.', true);
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holt-stat-rings"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('[data-holt-sr][data-animate="true"]').forEach(function (root) {
        var rings = root.querySelectorAll('[data-sr-ring]');
        if (!('IntersectionObserver' in window)) {
          rings.forEach(function (r) { r.classList.add('is-in'); });
          return;
        }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          });
        }, { threshold: 0.35 });
        rings.forEach(function (r) {
          if (r.dataset.bound === '1') return;
          r.dataset.bound = '1';
          io.observe(r);
        });
      });
    }
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState !== 'loading') init();
  })();

  } catch(e) { console.error(e); }
})();
})();
